const Null: React.FC = () => {
  return null;
};

export default Null;
